/**
 * TODO: this should be dedicated to a util package for reusability
 * where possible this logic should remain outside of component logic
 */
export var doesClientSupportStickPosition = function doesClientSupportStickPosition() {
  var el = document.createElement("a");
  var mStyle = el.style;
  mStyle.cssText = "position:sticky;position:-webkit-sticky;position:-ms-sticky;";
  return mStyle.position.indexOf("sticky") >= 0;
};
export var doesClientSupportScrollWithOptions = function doesClientSupportScrollWithOptions() {
  var supports = false;

  try {
    var div = document.createElement("div");
    div.scrollTo({
      top: 0,

      // tsc doesn't like `string` return type for this function signature
      // based on the `ScrollToOptions` interface
      get behavior() {
        supports = true;
        return "smooth";
      }

    });
  } catch (err) {
    supports = false;
  }

  return supports;
};